import classNames from "classnames/bind";
import styles from "./StreamCam.module.css";
import { Clock, ReactPlayer } from "../../../../components";
import SettingCamera from "./SettingCamera";
import WHEPPlayer from "../../../../components/WebRtc/WebRtc";
import { MenuIcon, OffStatus, OnStatusGreen, SmallZoomIcon, WeakStatus } from "../../../../components/Icons/Icons";
import ListAiHeader from "./ListAiHeader";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { CameraContext } from "../../LiveCamera";
import ModalInfoEvent from "./ModalInfoEvent";
import ModalCountPositionCarPark from "./ModalCountPositionCarPark";
import { format, formatDateToHour, getRoiList } from "../../../../utils";
import CanvasDraw from "../CanvasDraw";
import { aiConfigService } from "../../../../services/api/aiConfigService";
import axiosClient from "../../../../services/axiosClient";
import axiosClient_v2 from "../../../../services/axiosClient_v2";
import CanvasRegion from "../CanvasRegion";

const cx = classNames.bind(styles);

function OneCameraFullScreen(props) {
    const { handleWheel, handleMove, handleUp, setPointX, setPointY, limitChangePoint, refFullScreen, screens, sizeElement,
        handleReFreshAI, scale, panning, camera, companyCode, handleFull, showOptions, pointX, pointY, reload, setReload,
        image1, hikEvent, show, code, showInfoCamera, showSettingModal, restartCamera, point, onShowRename, setNameCamera,
        setCountCarPark, countCarPark, refreshCamera
    } = props;
    const { cameraActive } = React.useContext(CameraContext);
    const [eventInfo, setEventInfo] = useState({
        time: '',
        object: '',
        info: '',
        image: null,
        show: false
    })
    const [countPositionCarPart, setCountPositionCarPart] = useState(countCarPark ? countCarPark : {
        show: false,
        count: 0,
        total: 0
    })
    const getColorForNotification = (color) => {
        return color?.trim()?.length > 0 ? "#" + color : "#0400ff";
    };
    const [showModalPositionCarPark, setShowModalPositionCarPark] = useState(false);
    const [listPosition, setListPosition] = useState();
    const [showModalRegion, setShowModalRegion] = useState({
        show: false,
        region: [],
    });
    const refWrapperVideo = useRef(null);


    useEffect(() => {
        const event = camera?.find(n => n?.code === cameraActive[0]?.code);
        if (event) {
            if (event?.type_notification_code === "CODE_12") {
                // Nhận dạng mặt
                const face = {
                    time: formatDateToHour(event?.time),
                    object: event?.object,
                    info: event?.info,
                    image: event?.image,
                    show: true,
                }
                setEventInfo(face);
            } else if (event?.type_notification_code === "CODE_10") {
                // Nhận dạng biển số
                const license = {
                    time: formatDateToHour(event?.time),
                    object: event?.object,
                    info: event?.info,
                    image: process.env.REACT_APP_FSR_EVENT + event?.image,
                    show: true,
                }
                setEventInfo(license);
            } else if (event?.type_notification_code === "CODE_2") {
                if (event?.object_detail) {
                    const carPark = {
                        show: true,
                        count: event?.object_detail?.use_slot || 0,
                        total: event?.object_detail?.total_slot || 0
                    }
                    setCountPositionCarPart(carPark);
                    setCountCarPark(carPark);
                }
            }
        } else {
            const license = {
                time: '',
                object: "",
                info: "",
                image: "",
                show: false,
            }
            setEventInfo(license);
        }

    }, [camera, cameraActive])

    const getListParams = async (code, cameraCode) => {
        try {
            const param = {
                codeService: code,
                cameraCode: cameraCode
            }
            const res = await aiConfigService.get(param);
            setShowModalPositionCarPark(res[0]?.CODE === 31);
        } catch (error) {
            throw error;
        }
    };

    const handleParseData = (detail) => {
        const stringToJson = detail?.replaceAll("'", '"');
        const infoEvent = JSON.parse(stringToJson);
        return infoEvent;
    }

    const getNewEmptySlot = async (code, cameraCode) => {
        try {
            const date = new Date();
            const day = {
                date: format(date),
            }
            const res = await axiosClient_v2.get("/camAI/get-list-cam-ai/", {
                params: {
                    ai_service_code: code,
                    camera_code: cameraCode,
                    ...day,
                    page: 1,
                    size: 1,
                },
            });
            const detail = handleParseData(res?.data[0]?.detail);
            setCountPositionCarPart(pre => ({
                ...pre,
                count: detail?.use_slot || 0
            }))
        } catch (error) {
            throw error;
        }
    };


    useEffect(() => {
        const check = cameraActive[0]?.list_ai_service_registed?.some(sv => sv?.ai_service_code === "20230222000000000008") &&
            cameraActive[0]?.list_ai_service?.find(sv => sv?.ai_service_code === "20230222000000000008")?.status === 1;
        if (check) {
            getListParams("20230222000000000008", cameraActive[0]?.code);
            getNewEmptySlot("20230222000000000008", cameraActive[0]?.code);
        }
        setCountPositionCarPart(prev => ({ ...prev, show: check }))
    }, [cameraActive, refreshCamera])

    const getObjectCameraUniALPR = async (cameraCode) => {
        const width = 640;
        const height = 360;
        try {
            const res = await axiosClient.get(`aiConfigRoiList/get-list-ai-config-roi-list/?camera_code=${cameraCode}&ai_service_code=20230222000000000008`);
            let data = {};
            res.forEach(item => {
                data = item;
            })
            if (res && res.length > 0) {
                const arr = getRoiList(data?.ROI_LIST);
                const position = arr[0]?.map(item => {
                    return [item[0] * width / 100, item[1] * height / 100];
                })
                setListPosition(position);
                setCountPositionCarPart(pre => ({
                    ...pre,
                    total: position?.length || 0
                }))
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getObjectCameraUniALPR(cameraActive[0]?.code);
    }, [cameraActive[0]?.code, refreshCamera])


    // Check xem có bật nhận diện đối tượng phổ biến không

    const getParamSettingRegion = async (code, cameraCode) => {
        try {
            const param = {
                codeService: code,
                cameraCode: cameraCode
            }
            const res = await aiConfigService.get(param);
            const checlShow = res?.find(item => item?.CODE === 33)?.VALUE === '1'
            setShowModalRegion(pre => ({ ...pre, show: checlShow }));
        } catch (error) {
            throw error;
        }
    }

    useEffect(() => {
        const check = cameraActive[0].list_ai_service_registed?.some(sv => sv?.ai_service_code === "20230222000000000004") &&
            cameraActive[0].list_ai_service?.find(sv => sv?.ai_service_code === "20230222000000000004")?.status === 1;
        if (check) {
            console.log(refreshCamera);
            getParamSettingRegion("20230222000000000004", cameraActive[0].code);
        }
    }, [cameraActive[0]?.code, refreshCamera]);

    return (
        <div
            onWheel={handleWheel}
            onMouseDown={(e) => handleMove(e)}
            onMouseUp={(e) => handleUp(e)}
            onMouseMove={(e) => {
                if (scale !== 1) {
                    if (!panning) {
                        return;
                    }
                    setPointX(
                        limitChangePoint(
                            e.clientX - point.x,
                            e.target.getBoundingClientRect().width - sizeElement.width
                        )
                    );

                    setPointY(
                        limitChangePoint(
                            e.clientY - point.y,
                            e.target.getBoundingClientRect().height - sizeElement.height
                        )
                    );
                }
            }}
            className={cx("one-camera-full-screen")}
            ref={refFullScreen}
        >
            {cameraActive?.length > 0 &&
                cameraActive?.map((item, index) => {
                    if (index + 1 <= screens.total && item?.code) {
                        return (
                            <div className={cx("videoFull")} key={index}>
                                <div
                                    className={cx("full-video")}
                                    style={
                                        camera.some((item1) => item1.code === item.code)
                                            ? {
                                                borderImageSource: `linear-gradient(to bottom, ${getColorForNotification(
                                                    camera?.find((n) => n.code === item?.code)
                                                        ?.color
                                                )}  , ${getColorForNotification(
                                                    camera?.find((n) => n.code === item?.code)
                                                        ?.color
                                                )})`,
                                                display: "block",
                                            }
                                            : {}
                                    }
                                ></div>
                                <div
                                    className={cx("setting")}
                                    style={
                                        camera.some((item1) => item1.code === item.code)
                                            ? {
                                                background: getColorForNotification(
                                                    camera?.find((n) => n.code === item?.code)
                                                        ?.color
                                                ),
                                                display: "flex",
                                            }
                                            : { display: "flex" }
                                    }
                                >
                                    <div
                                        // style={{ width: "60%" }}
                                        className={cx("name_status")}
                                    >
                                        {companyCode === "DEFAULT" ? (
                                            <span className={cx("On")}>
                                                {item?.status === "On" ? (
                                                    <OnStatusGreen />
                                                ) : item?.status === "Off" ? (
                                                    <OffStatus />
                                                ) : (
                                                    <WeakStatus />
                                                )}
                                            </span>
                                        ) : (
                                            <span className={cx("On")}>
                                                {item?.status === "On" ? (
                                                    <OnStatusGreen />
                                                ) : (
                                                    <OffStatus />
                                                )}
                                            </span>
                                        )}
                                        <span
                                            style={{ fontSize: 18, maxWidth: "100%" }}
                                            className={cx("name")}
                                        >
                                            {item.name}
                                        </span>
                                    </div>
                                    <ListAiHeader
                                        infoAi={item}
                                        restartCamera={handleReFreshAI}
                                    />
                                    <div className={cx("icon")}>
                                        <span
                                            onClick={(e) =>
                                                handleFull(item.name, "small", item.code)
                                            }
                                        >
                                            <SmallZoomIcon />
                                        </span>
                                        <span
                                            className={cx("menu")}
                                            onClick={(e) => showOptions(item.code)}
                                        >
                                            <MenuIcon />
                                        </span>
                                    </div>
                                </div>
                                {item?.status === "On" ? (
                                    !item.rtc ? (
                                        <ReactPlayer
                                            url={item?.url2}
                                            scale={scale}
                                            pointX={pointX}
                                            pointY={pointY}
                                            ref={refWrapperVideo}
                                        />
                                    ) : (
                                        <div style={{ width: "89vw" }} ref={refWrapperVideo}>
                                            <WHEPPlayer
                                                channelUrl={item.rtc}
                                                reload={reload}
                                                setReload={setReload}
                                            />
                                        </div>
                                    )
                                ) : (
                                    <img
                                        src={image1}
                                        alt={"image"}
                                        style={{
                                            width: "100%",
                                            objectFit: "cover",
                                            height: "100%",
                                        }}
                                    />
                                )}
                                <div className={cx("footer")}>
                                    <div className={cx("icon")} style={{ width: "100%" }}>
                                        <Clock
                                            type_camera={item.type_camera}
                                            temperature={
                                                hikEvent?.length > 0
                                                    ? hikEvent?.find(
                                                        (e) => e?.camera_code === item?.code
                                                    )?.temperature
                                                    : item.temperature
                                            }
                                            fontSize={36}
                                        />
                                    </div>
                                </div>
                                <SettingCamera
                                    show={show}
                                    item={item}
                                    code={code}
                                    showInfoCamera={showInfoCamera}
                                    showSettingModal={showSettingModal}
                                    restartCamera={restartCamera}
                                    onShowRename={onShowRename}
                                    setNameCamera={setNameCamera}
                                    reFreshCamera={handleReFreshAI}
                                />
                                {
                                    eventInfo?.show && (
                                        <div className={cx('modal')}>
                                            <ModalInfoEvent detail={eventInfo} fullScreen={true} screen={1} />
                                        </div>
                                    )
                                }
                                {
                                    countPositionCarPart?.show && (
                                        <div className={cx('modal')}>
                                            <ModalCountPositionCarPark detail={countPositionCarPart} fullScreen={true} screen={1} />
                                        </div>
                                    )
                                }
                                {
                                    showModalPositionCarPark &&
                                    <div className={cx("modal-view-position")}>
                                        <CanvasDraw cameraCode={item?.code} listPosition={listPosition} />
                                    </div>
                                }
                                {
                                    showModalRegion?.show && (
                                        <div className={cx('modal-view-position')}>
                                            <CanvasRegion
                                                cameraCode={item?.code}
                                                listPosition={showModalRegion?.region}
                                                width={refWrapperVideo?.current?.clientWidth}
                                                height={refWrapperVideo?.current?.clientHeight}
                                                codeService={"20230222000000000004"}
                                                refreshCamera={refreshCamera}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        );
                    } else {
                        return <Fragment key={index} />;
                    }
                })}
        </div>
    )
}

export default OneCameraFullScreen;